// Scroll Animation Utility - ใช้ Intersection Observer สำหรับ performance
// ใช้ CSS animations แทน JavaScript animations เพื่อให้เบา

const initScrollAnimations = () => {
    // ตรวจสอบว่า browser รองรับ Intersection Observer หรือไม่
    if (!('IntersectionObserver' in window)) {
        // Fallback: แสดง animations ทันทีถ้าไม่รองรับ
        const elements = document.querySelectorAll('.animate-on-scroll');
        elements.forEach(el => el.classList.add('animated'));
        return;
    }

    // สร้าง Intersection Observer
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1 // Trigger เมื่อเห็น 10% ของ element
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animated');
                // Unobserve หลังจาก animate แล้วเพื่อ performance
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Observe ทุก element ที่มี class animate-on-scroll
    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach(el => observer.observe(el));
};

// Initialize เมื่อ DOM พร้อม
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
} else {
    initScrollAnimations();
}

// Re-initialize สำหรับ React Router navigation
export const reinitScrollAnimations = () => {
    setTimeout(initScrollAnimations, 100);
};

export default initScrollAnimations;





















